/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Col_SourceInputs */

const en_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const de_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const fr_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const es_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const it_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const nl_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const pl_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const fi_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const da_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const sv_portal_scanner_col_source = /** @type {(inputs: Portal_Scanner_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Portal_Scanner_Col_SourceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_col_source = /** @type {((inputs?: Portal_Scanner_Col_SourceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Col_SourceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_col_source(inputs)
	if (locale === "fr") return fr_portal_scanner_col_source(inputs)
	if (locale === "es") return es_portal_scanner_col_source(inputs)
	if (locale === "it") return it_portal_scanner_col_source(inputs)
	if (locale === "nl") return nl_portal_scanner_col_source(inputs)
	if (locale === "pl") return pl_portal_scanner_col_source(inputs)
	if (locale === "fi") return fi_portal_scanner_col_source(inputs)
	if (locale === "da") return da_portal_scanner_col_source(inputs)
	if (locale === "sv") return sv_portal_scanner_col_source(inputs)
	return en_portal_scanner_col_source(inputs)
});